module.exports = __webpack_public_path__ + "static/media/CreditMemo3.67e3da7b.png";